var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSafeFamily = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 143.479 143.479"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.85
}, /*#__PURE__*/React.createElement("path", {
  d: "M71.74 81.267a4.2 4.2 0 01-1.208-.177A43.525 43.525 0 0139.513 39.4V15.413a4.2 4.2 0 014.2-4.2 13.857 13.857 0 0012.463-7.7l.592-1.183A4.2 4.2 0 0160.53 0h22.419a4.2 4.2 0 013.76 2.324l.592 1.183a13.857 13.857 0 0012.463 7.7 4.2 4.2 0 014.2 4.2V39.4a43.525 43.525 0 01-31.019 41.69 4.2 4.2 0 01-1.205.177z",
  fill: "#9ddff6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.763 11.209a13.858 13.858 0 01-12.462-7.7l-.592-1.183A4.2 4.2 0 0082.949 0H71.74v81.267a4.2 4.2 0 001.208-.177 43.525 43.525 0 0031.019-41.69V15.413a4.2 4.2 0 00-4.204-4.204z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.92 19.225V39.4a34.891 34.891 0 0023.82 33.252A34.891 34.891 0 0095.56 39.4V19.225A22.178 22.178 0 0180.392 8.407h-17.3A22.178 22.178 0 0147.92 19.225z",
  fill: "#f5f5ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.392 8.407H71.74v64.245A34.891 34.891 0 0095.56 39.4V19.225A22.179 22.179 0 0180.392 8.407z",
  fill: "#e2e7fa"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.773 52.763a4.188 4.188 0 01-2.972-1.231l-7.926-7.926a4.204 4.204 0 015.945-5.945l4.954 4.954 12.88-12.88a4.204 4.204 0 015.945 5.945L70.747 51.532a4.191 4.191 0 01-2.974 1.231z",
  fill: "#ab80e3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.657 29.735l-8.917 8.917v11.889l14.862-14.862a4.204 4.204 0 00-5.945-5.945z",
  fill: "#6e61b7"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M29.424 95.839A29.458 29.458 0 000 125.263v14.012a4.2 4.2 0 004.2 4.2h43.72l9.094-28.436a29.473 29.473 0 00-27.59-19.2z",
  fill: "#ff66c4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.924 143.479l9.09-28.44a29.473 29.473 0 00-27.59-19.2v47.64z",
  fill: "#e557b1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.424 104.246a18.215 18.215 0 1118.215-18.215 18.236 18.236 0 01-18.215 18.215z",
  fill: "#ffd5b2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.639 86.031a18.236 18.236 0 00-18.215-18.215v36.43a18.236 18.236 0 0018.215-18.215z",
  fill: "#fac394"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.054 95.839a29.473 29.473 0 00-27.568 19.14l9.073 28.5h43.716a4.2 4.2 0 004.2-4.2v-14.016a29.458 29.458 0 00-29.421-29.424z",
  fill: "#ab80e3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.275 143.479a4.2 4.2 0 004.2-4.2v-14.016a29.458 29.458 0 00-29.421-29.424v47.64z",
  fill: "#6e61b7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.054 104.246a18.215 18.215 0 1118.215-18.215 18.236 18.236 0 01-18.215 18.215z",
  fill: "#ffd5b2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.269 86.031a18.236 18.236 0 00-18.215-18.215v36.43a18.236 18.236 0 0018.215-18.215z",
  fill: "#fac394"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.56 143.479H47.92v-9.5a23.821 23.821 0 1147.64-.3z",
  fill: "#e7f0ef"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.74 109.853v33.626h23.82v-9.808a23.845 23.845 0 00-23.82-23.818z",
  fill: "#d8e6e8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.74 118.258a15.413 15.413 0 1115.413-15.413 15.43 15.43 0 01-15.413 15.413z",
  fill: "#ffd5b2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.153 102.845A15.43 15.43 0 0071.74 87.432v30.826a15.43 15.43 0 0015.413-15.413z",
  fill: "#fac394"
})))));
export default SvgSafeFamily;